(function () {
    'use strict';

    angular
        .module('riskSelfAssessmentReviewControllers')
        .controller('RiskSelfAssessmentReviewTopRiskListController', Controller);

    Controller.$inject = ['$scope', '$filter', 'topBarService', 'govProcess', 'topRisksToReview'];

    function Controller($scope, $filter, topBarService, govProcess, topRisksToReview) {
        topBarService.setTitleAndIcon(govProcess.DisplayName, 'fa fa-umbrella');

        $scope.ctrlCtxt = {};
        $scope.filteredRisksToReview  = topRisksToReview;
        $scope.nbMaxDisplay           = 41;
        $scope.ctrlCtxt.selectedTopRisk = {RiskID: null};

        // Filter Risks
        var filteredRiskToReviewFields = ['Risk.RiskLevel.TitleEN',
                                          'Risk.DisplayRiskID',
                                          'Risk.Name',
                                          'Risk.Description',
                                          'Risk.RiskType.RiskClass.TitleEN'];

        $scope.filterRisksToReview = function () {

            if ($scope.ctrlCtxt.search.length === 0) {
                $scope.filteredRisksToReview = topRisksToReview;
            }
            else if ($scope.ctrlCtxt.search.length < 3) {
                $scope.filteredRisksToReview = [];
            }
            else {
                var filteredRisksToReview = $filter('filterBy')(topRisksToReview, filteredRiskToReviewFields, $scope.ctrlCtxt.search);
                $scope.filteredRisksToReview = _.chain(filteredRisksToReview)
                                        .take($scope.nbMaxDisplay)
                                        .filter(function (riskToReview) {
                                            if (!riskToReview.Risk.IsClosed) return true;
                                            return $scope.authenticatedUser.User.IsInRiskManagementGroup;
                                        })
                                        .value();
            }
        };

    }
})();
